module.exports = __webpack_public_path__ + "static/media/2_of_diamonds.1fc5521b.png";